import React, { useEffect, useState } from 'react';
import { useAuth } from '../contextos/AuthProvider'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Prepago from './Prepago';
import ReportarPago from './ReportarPago';
import { EncApi, EncabezadoPost } from '../Comunes/Listas';

const BasePagos = () => {
    const { PerfilUsuario, Token } = useAuth();
    const navigate = useNavigate();
    const Salir = () => {
        navigate("/");
    };

    const handleOnSubmit = async (e) => {
        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };
    const [Gestor, setGestor] = useState(null);
    const Modificar = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'Banco':
                RefrescaCuentas(value);
                break;
            default:
                setGestor((prevState) => ({
                    ...prevState,
                    [name]: value
                }));
                break;
        }

    };

    
    const RefrescaCuentas = async (banco) => {
        const URL = 'https://smartfecr.com:2020/SmartContrackBack/api/Companias/ObtenerCuentasBanco?idCia=' + PerfilUsuario.IdCia + '&codigoBanco=' + banco;
        console.log(URL);
        await fetch(URL,EncApi(Token)).then(response => response.json())
            .then(json => {
                if (json.Codigo === 0) {
                    setGestor((prevState) => ({
                        ...prevState,
                        Cuentas: json.Datos,
                        Banco: banco,
                        Cuenta: json.Datos.length > 0 ? json.Datos[0].CODIGO : '0'
                    }));
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: json.Mensaje,
                        showConfirmButton: true,
                    });
                }
            }
            ).catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar cuentas ' + error,
                    showConfirmButton: true,
                });
            });
    }


    const CargandoDatosIniciales = async () => {
        if (PerfilUsuario) {


            await fetch('https://smartfecr.com:2020/SmartContrackBack/api/Companias/MiEsquemaPagos?idCia=' + PerfilUsuario.IdCia, EncApi(Token)
            ).then(response => response.json())
                .then(json => {

                    if (json.Codigo === 0) {
                        //console.log(json);
                        let NuevoGestor = {
                            PagosPendiente: json.Datos.PagoPendiente,
                            Bancos: json.Datos.Bancos,
                            Cuentas: json.Datos.CuentasBanco,
                            VerificacionPaquete: json.Datos.VerificaPaquete,
                            PlanesVigentes: json.Datos.PlanesVigentes,
                            ConsumoActual: json.Datos.ConsumoActual,
                            MisActividades: json.Datos.MisActividades,
                            ActCliente: json.Datos.MisActividades.length > 0 ? json.Datos.MisActividades[0].CodigoActividad : '0',
                            Plan: json.Datos.Plan,
                            PlanPrepago: '11',
                            Banco: '3',
                            Ambiente: PerfilUsuario.IdCia === 1 ? 'False' : 'True',
                            NumOrden: json.Datos.PagoPendiente.length > 0 ? json.Datos.PagoPendiente[0].Codigo : '0',
                            Cuenta: '5',
                            Comprobante: '',
                            FechaPago: json.Datos.HoraServidor,
                            HoraServidor: json.Datos.HoraServidor,
                        }
                        setGestor(NuevoGestor);
                        console.log(NuevoGestor);

                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar los datos iniciales.',
                            showConfirmButton: true,
                        });
                    }
                }
                ).catch(error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los datos iniciales.' + error,
                        showConfirmButton: true,
                    });
                });
        }
    }

    const AdquirirPlan = async () => {

        Swal.fire({
            title: '¿Está seguro?',
            text: "Confirme si desea continuar con esta acción.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, de acuerdo',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const URL = 'https://smartfecr.com:2020/SmartContrackBack/api/Companias/GuardaPlan?idCia=' + PerfilUsuario.IdCia + '&plan=' + Gestor.PlanPrepago;
                console.log(URL);
                await fetch(URL, EncApi(Token)).then(response => response.json())
                    .then(json => {
                        if (json.Codigo === 0) {
                            if (json.Datos[0].ID > 0) {
                                CargandoDatosIniciales();
                            }
                            else {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error',
                                    text: json.Datos[0].Mensaje,
                                    showConfirmButton: true,
                                });
                            }
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: json.Mensaje,
                                showConfirmButton: true,
                            });
                        }
                    }
                    ).catch(error => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar cuentas ' + error,
                            showConfirmButton: true,
                        });
                    });
            }
            else {
                return; // Abort the process if the user cancels
            }
        });



    }

    const ReportarPagoPcService = async () => {
        console.log("Pagos");
        if (Gestor.Comprobante === '') {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe ingresar el número de comprobante.',
                showConfirmButton: true,
            });
            return;
        }
        if (Gestor.Cuenta === '0') {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe seleccionar una cuenta.',
                showConfirmButton: true,
            });
            return;
        }
        if (Gestor.NumOrden === '0') {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No hay pagos pendientes.',
                showConfirmButton: true,
            });
            return;
        }

        Swal.fire({
            title: '¿Está seguro de reportar el pago?',
            showCancelButton: true,
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            confirmButtonText: 'Sí, de acuerdo',
            cancelButtonText: 'Cancelar',
            preConfirm: async () => {
                const URL = 'https://smartfecr.com:2020/SmartContrackBack/api/Companias/ReportarPago';
                console.log(URL);
                const datosPago = {
                    Ambiente: PerfilUsuario.IdCia === 1 ? 'False' : 'True',
                    NumOrden: parseInt(Gestor.NumOrden),
                    Cuenta: parseInt(Gestor.Cuenta),
                    Comprobante: Gestor.Comprobante,
                    FechaPago: Gestor.FechaPago,
                    ActCliente: Gestor.ActCliente,
                };
                console.log(datosPago);
                await fetch(URL, EncabezadoPost(Token, datosPago))
                    .then(response => response.json())
                    .then(json => {
                        if (json.Codigo === 0) {
                            if (json.Datos[0].Id > 0) {


                            CargandoDatosIniciales();
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Pago reportado correctamente. '+ json.Datos[0].Mensaje,
                                showConfirmButton: true,
                            });
                        }
                            else {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error',
                                    text: json.Datos[0].Mensaje,
                                    showConfirmButton: true,
                                });
                            }
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: json.Mensaje,
                                showConfirmButton: true,
                            });
                        }
                    }
                    ).catch(error => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar cuentas ' + error,
                            showConfirmButton: true,
                        });
                    });
            }
        });

    }

    useEffect(() => {
        if (PerfilUsuario) {
            CargandoDatosIniciales();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps       
    }, [PerfilUsuario]);

    if (Gestor) {
        return (

            <div className='main-block'>
                <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                    <div className='formadoShadow'>

                        <div className='tituloPantalla'>
                            <p style={{ display: 'inline-block' }}> Pagos y Planes</p>
                            <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                        </div>

                        {Gestor.Plan === 'D' ? <Prepago Gestor={Gestor} Modificar={Modificar} AdquirirPlan={AdquirirPlan} /> : null}
                        <ReportarPago Gestor={Gestor} Modificar={Modificar} ReportarPagoPcService={ReportarPagoPcService} />

                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f9f9f9',
                fontFamily: 'Arial, sans-serif',
                color: '#555',
                textAlign: 'center'
            }}>
                <div>
                    <p style={{
                        fontSize: '18px',
                        marginBottom: '10px'
                    }}>Cargando Información...</p>
                    <p style={{
                        fontSize: '14px',
                        color: '#888'
                    }}>Por favor, espere mientras se cargan los datos necesarios.</p>
                </div>
            </div>
        );
    }

};

export default BasePagos;